import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { ProfilePage } from '../pages';

export const routes = (
  <Route
    path="/profile/:tab?"
    element={
      <PrivateRoute>
        <ProfilePage />
      </PrivateRoute>
    }
  />
);
